import { createFileRoute } from '@tanstack/react-router';

import { Link as TWLink } from 'web2/app/components/link';
import InlineSubscribeToSignUp from 'web2/app/components/inline-subscribe-to-sign-up';
import { preloadImageByKey } from '../../../lib/utils';
import { useAutoSetTheme } from 'shared/misc/providers/ThemeContext';
import { ProfileThemeType } from 'shared/__generated__/graphql';

export const Route = createFileRoute('/welcome/')({
  component: LandingPage,
  // ssr: false,
  head: () => ({
    meta: [
      {
        title: 'Perfectly Imperfect',
        description: "A taste of someone's taste.",
        openGraph: {
          images: [
            'https://files.pi.fyi/cdn-cgi/image/quality=50,format=auto/app-info-screenshot.png',
          ],
        },
      },
    ],
  }),
  loader: async () => {
    try {
      preloadImageByKey('star-background.png');
      preloadImageByKey('app-info-screenshot.png');
      preloadImageByKey('pi-goated-tweet.png');
    } catch (error) {
      console.error(error);
    }
  },
});

function LandingPage() {
  useAutoSetTheme(ProfileThemeType.PiClassic);

  return (
    <>
      <div
        className="flex flex-col h-full w-full items-center justify-center"
        style={{
          backgroundImage: 'url(https://files.pi.fyi/star-background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="mt-6 md:mt-12 m-6 md:m-12 w-full lg:w-[800px]">
          <div className="flex flex-col w-full p-4 md:p-0">
            <div className="flex justify-center mb-[12px] hidden sm:flex">
              <img
                src="/static/logo-horizontal.svg"
                alt="Logo"
                className="self-center filter invert w-[300px] sm:w-[400px] h-auto"
              />
            </div>

            <div className="flex flex-col gap-[6px] sm:mb-[12px] md:p-[24px]">
              <div className="typography-heading-xl sm:text-[default] sm:typography-heading-xl text-left sm:text-center text-brand-highlight mb-[12px] ">
                A<br />
                Taste
                <br />
                of
                <br />
                Taste
              </div>

              <div className="typography-heading-sm sm:typography-heading-md sm:text-center text-brand-main mb-[12px] sm:mt-[12px] sm:px-[64px]">
                Join the <span className="text-brand-highlight">130,000+ people</span> enhancing
                their taste with Perfectly Imperfect.
              </div>

              <div className="md:py-[12px]">
                <InlineSubscribeToSignUp
                  ctaText="share what you love on PI.FYI"
                  submitText="Join or Sign In"
                  confirmationText="Welcome!"
                  // redirectTo="/sign-up/more"
                  withBorder={false}
                  withPadding={false}
                  withAutoFocus
                  withFinishSignUpModal
                  withInputDashedBorder
                  onlyInput
                />
              </div>
              <div className="flex flex-col gap-3 mt-[6px]">
                <div className="typography-body-sm text-brand-lightgrey text-left">
                  By clicking "JOIN" you agree to our{' '}
                  <TWLink
                    to="/terms"
                    className="text-brand-highlight hover:underline "
                    variant="stylized"
                  >
                    Terms
                  </TWLink>{' '}
                  and{' '}
                  <TWLink
                    to="/terms"
                    className="text-brand-highlight hover:underline "
                    variant="stylized"
                  >
                    Privacy
                  </TWLink>{' '}
                  conditions.
                </div>
                {/* <div className="typography-body-sm text-brand-lightgrey text-left">
                  Already signed up?{' '}
                  <TWLink
                    to="/sign-in"
                    className="text-brand-highlight hover:underline "
                    variant="stylized"
                  >
                    Sign in
                  </TWLink>
                </div>
                <div className="typography-body-sm text-brand-lightgrey text-left">
                  Confused?{' '}
                  <TWLink
                    to="/what-is-this"
                    className="text-brand-highlight hover:underline"
                    variant="stylized"
                  >
                    Learn more
                  </TWLink>
                </div> */}
              </div>
              <div className="flex sm:justify-center w-full mt-6 mb-[24px]">
                <a
                  href="https://apps.apple.com/us/app/pi-fyi-by-perfectly-imperfect/id6474037926"
                  target="_blank"
                >
                  <img
                    src="https://files.pi.fyi/App_Store_Badge.png"
                    alt="star-blue"
                    width={500}
                    height={160}
                    className="max-w-[150px] sm:max-w-[200px] h-auto"
                  />
                </a>
              </div>
            </div>
            <div className="flex flex-col gap-1.5 border-[1px] border-dashed border-brand-main p-[12px] md:p-[24px] mt-[6px]">
              <div className="typography-heading-md sm:typography-heading-lg leading-[150%] text-left md:text-center text-brand-title-background mb-[6px]">
                A Cult-favorite Newsletter
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main">
                Interviews ft recommendations from Charli XCX, Lorde, Francis Ford Coppola, Ayo
                Edebiri, The Rizzler, Olivia Rodrigo, Michael Imperioli, Emma Chamberlain, Clairo,
                Ice Spice, Molly Ringwald, Weyes Blood, Jeremy O. Harris, Conner O'Malley,
                PinkPantheress, Rayne Fisher Quann, Julian Casablancas, Alexa Chung, Mac Demarco,
                Moses Sumney, Omar Apollo, Suki Waterhouse, Nardwuar, The Dare, and hundreds more in{' '}
                <TWLink
                  to="/read"
                  className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main"
                  variant="stylizedNoDefaultBorder"
                >
                  the Perfectly Imperfect Archive.
                </TWLink>
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main mb-[12px]">
                The history and impact of Perfectly Imperfect is well-documented by The New York
                Times, NYMag, Vanity Fair, Interview Mag, Flaunt, Office, The Verge, and NPR.
              </div>
              <InlineSubscribeToSignUp
                ctaText="share what you love on PI.FYI"
                submitText="Subscribe"
                confirmationText="Welcome!"
                redirectTo="/read"
                withBorder={false}
                withPadding={false}
                withAutoFocus
                withFinishSignUpModal
                withInputDashedBorder
                onlyInput
              />
              <img
                src="https://files.pi.fyi/lick.jpg"
                width={400}
                height={60}
                alt="Logo"
                className="w-full h-auto mt-[12px]"
              />
            </div>
            <div className="flex flex-col gap-1.5 border-[1px] border-dashed border-brand-main p-[12px] md:p-[24px]">
              <div className="typography-heading-md sm:typography-heading-lg text-left md:text-center text-brand-title-background leading-[150%] mb-[6px]">
                An app for your taste
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main">
                All the best parts of MySpace, Letterboxd, Reddit, Twitter, Tumblr, and Pinterest,
                combined into the perfect site.
              </div>
              <div className="typography-action-sm text-[14px] sm:text-[18px] leading-[150%] text-brand-main mb-[12px]">
                You can...discover new things from real people, share your best recommendations,
                theme your profile, log what brings you joy, connect over your interests, build
                custom lists, go to events, and much more.
              </div>
              <img
                src="https://files.pi.fyi/app-info-screenshot.png"
                width={400}
                height={60}
                alt="Logo"
                className="w-full h-auto"
              />
              <div className="flex justify-center w-full mt-12 mb-4">
                <a
                  href="https://apps.apple.com/us/app/pi-fyi-by-perfectly-imperfect/id6474037926"
                  target="_blank"
                >
                  <img
                    src="https://files.pi.fyi/App_Store_Badge.png"
                    alt="star-blue"
                    width={500}
                    height={160}
                    style={{
                      maxWidth: '200px',
                    }}
                  />
                </a>
              </div>
            </div>

            {/* <Text textStyle="brand.headingMd" color="brand.highlight" textAlign="center">
              Thousands of people are sharing what they love on PI.FYI.
            </Text>
            <Text textStyle="brand.headingMd" color="brand.highlight" textAlign="center">
              Why aren't you?
            </Text> */}
          </div>
        </div>
      </div>
    </>
  );
}
